import { ProjectTemplatesCreateProjectFromTemplateModule } from './project-templates-create-project-from-template/project-templates-create-project-from-template.module';
import { ConfirmationPopUpModule } from './../../../widgets/confirmation-pop-up/confirmation-pop-up.module';
import { TemplateProjectTaskPopupModule } from './../../task/template-project-task-popup/template-project-task-popup.module';
import { InfoHeaderModule } from './../../../widgets/info-header/info-header.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectTemplatesRoutingModule } from './project-templates-routing.module';
import { ProjectTemplatesComponent } from './project-templates.component';
import { ProjectService } from '../project.service';
import { DxPopupModule, DxButtonModule, DxLoadPanelModule, DxSelectBoxModule, DxGanttModule, DxDateBoxModule, DxTextBoxModule, DxLookupModule } from 'devextreme-angular';
import { DxoRowDraggingModule } from 'devextreme-angular/ui/nested';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';


@NgModule({
  declarations: [ProjectTemplatesComponent],
  imports: [
    CommonModule,
    ProjectTemplatesRoutingModule,
		DxPopupModule,
		DxButtonModule,
		DxLoadPanelModule,
		DxSelectBoxModule,
		DxGanttModule,
		ProjectTemplatesCreateProjectFromTemplateModule,
		InfoHeaderModule,
		DxDateBoxModule,
		DxTextBoxModule,
		TemplateProjectTaskPopupModule,
		DxoRowDraggingModule,
		ConfirmationPopUpModule,
		DxLookupModule,
		ContainerComponent,
		HelpButtonComponent,
  ],
  providers: [ProjectService]
})
export class ProjectTemplatesModule { }
